export default __webpack_public_path__ + "static/media/games-header-bg.986e3ac1.png";